import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import moment from 'moment';
import systemclass_analysis from './systemclass_analysis';

export default {
  async create(factoryId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'internal_training',
      data: _data,
    });
    return res;
  },
  async update(internalTrainingId, data) {
    const currentFactory = store.state.app.factory;
    const _data = {
      factory: currentFactory.id,
      ...data,
    };
    const res = await base.update({
      url: `factory/${currentFactory.id}/internal_training/${internalTrainingId}`,
      data: _data,
    });
    return res;
  },
  async show(internalTrainingId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${currentFactory.id}/internal_training/${internalTrainingId}`,
      params: _params,
    });
    return res;
  },
  async delete(internalTrainingId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      url: `factory/${currentFactory.id}/internal_training/${internalTrainingId}`,
      params: _params,
    });
    return res;
  },
  async index(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'internal_training',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async printIndex(factoryId, params, type = 'factory') {
    //取得changeList print內容
    const currentOrganization = store.state.app.organization;
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentOrganization.id;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'internal_training_print/index',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async indexAll(factoryId, params) {
    //board calender
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      get_all: 1,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'internal_training',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async remarkUpdate(internalTrainingId, data) {
    const currentFactory = store.state.app.factory;
    const _data = {
      factory: currentFactory.id,
      ...data,
    };
    const res = await base.update({
      url: `factory/${currentFactory.id}/internal_training/${internalTrainingId}/remark`,
      data: _data,
    });
    return res;
  },
  getCardsData(apiData) {
    apiData = systemclass_analysis.userSystemSubclassesAuthCheck(apiData)
    const result = apiData.map((train)=>{
      let content = [
        {
          title: "訓練日期",
          text: train.train_at
          ? moment(train.train_at).format("YYYY-MM-DD")
          : null,
        },
        {
          title: "負責人",
          text: train.principal.name,
        },
      ]
      let trainingContent = {
        content,
        id: train.id,
        name: train.name,
        system_subclasses: train.system_subclasses,
      };
      return trainingContent;
    })
    return result
  },
  async indexAuth(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'internal_training/index/auth',
      params: _params,
    });
    return res;
  },
  async createGroup(data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'internal_training_group',
      data: _data,
    });
    return res;
  },
  async updateGroup(groupId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'internal_training_group',
      modelId: groupId,
      data: _data,
    });
    return res;
  },
  async showGroup(groupId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'internal_training_group',
      modelId: groupId,
      params,
    });
    return res;
  },
  async deleteGroup(groupId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.delete({
      modelName: 'internal_training_group',
      modelId: groupId,
      params,
    });
    return res;
  },
  async lackIndexByGroup(groupId, params) {
    const _params = {
      factory: store.state.app.factory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'internal_training_group',
      parentId: groupId,
      modelName: 'training_time_record/index/lack',
      params: _params,
    });
    return res;
  },
  async deleteTimeRecord(timeRecordId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.delete({
      modelName: 'training_time_record',
      modelId: timeRecordId,
      params,
    });
    return res;
  },
  async batchDeleteTimeRecord(internalTrainingId, timeRecordIdList) {
    const params = {
      factory: store.state.app.factory.id,
      ids: timeRecordIdList
    };
    const res = await base.delete({
      url: `internal_training/${internalTrainingId}/delete/batch/training_time_record`,
      params,
    });
    return res;
  },
};
